import { X, Check, Minus } from "lucide-react";
import { useI18n } from "../../i18n";

const ROWS = [
  ["comp_row1", true, false, "p"],
  ["comp_row2", true, false, false],
  ["comp_row3", true, false, false],
  ["comp_row4", true, "p", false],
  ["comp_row5", true, false, "p"],
  ["comp_row6", true, false, false],
  ["comp_row7", true, false, "p"],
  ["comp_row8", true, false, false],
  ["comp_row9", true, false, true],
  ["comp_row10", true, false, false],
];

function Cell({ v }) {
  if (v === true) return <Check className="w-4 h-4 text-[color:var(--green)] mx-auto" />;
  if (v === false) return <X className="w-4 h-4 text-[#ff5c5c]/70 mx-auto" />;
  return <Minus className="w-4 h-4 text-[color:var(--gold)] mx-auto" />;
}

export default function Comparison() {
  const { t } = useI18n();
  return (
    <section id="comparison" className="relative py-16 sm:py-20 lg:py-28">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="chip">{t("comp_chip")}</span>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.05]">
            {t("comp_h1_a")} <span className="text-[color:var(--gold)]">{t("comp_h1_b")}</span>
          </h2>
          <p className="text-[color:var(--ink-dim)] mt-4 leading-relaxed text-sm sm:text-base">{t("comp_sub")}</p>
        </div>

        <div className="mt-10 sm:mt-12 panel overflow-hidden">
          <div className="grid grid-cols-[1.4fr_0.9fr_0.9fr_0.9fr] sm:grid-cols-[1.5fr_1fr_1fr_1fr] text-[11px] sm:text-sm">
            <div className="p-3 sm:p-5 font-mono text-[9px] sm:text-[10px] uppercase tracking-widest text-[color:var(--ink-mute)] border-b border-[#23232a]">
              {t("comp_capability")}
            </div>
            {[
              { k: "comp_col1", accent: true },
              { k: "comp_col2" },
              { k: "comp_col3" },
            ].map((c) => (
              <div key={c.k} className={`p-3 sm:p-5 text-center font-display font-bold border-b border-[#23232a] text-[11px] sm:text-sm ${
                c.accent ? "text-[color:var(--gold)] bg-[rgba(231,180,59,.05)]" : "text-white/70"
              }`}>{t(c.k)}</div>
            ))}

            {ROWS.map((row, i) => (
              <div key={i} className="contents">
                <div className="p-3 sm:p-5 text-[color:var(--ink-dim)] border-b border-[#23232a]/60 text-[12px] sm:text-sm">{t(row[0])}</div>
                {[row[1], row[2], row[3]].map((v, j) => (
                  <div key={j} className={`p-3 sm:p-5 grid place-items-center border-b border-[#23232a]/60 ${j === 0 ? "bg-[rgba(231,180,59,.03)]" : ""}`}>
                    <Cell v={v === "p" ? "partial" : v} />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className="text-[11px] sm:text-xs text-[color:var(--ink-mute)] mt-4 flex flex-wrap gap-3 sm:gap-5">
          <span className="flex items-center gap-1.5"><Check className="w-3.5 h-3.5 text-[color:var(--green)]" /> {t("comp_yes")}</span>
          <span className="flex items-center gap-1.5"><X className="w-3.5 h-3.5 text-[#ff5c5c]/70" /> {t("comp_no")}</span>
          <span className="flex items-center gap-1.5"><Minus className="w-3.5 h-3.5 text-[color:var(--gold)]" /> {t("comp_partial")}</span>
        </div>
      </div>
    </section>
  );
}
